/**
 * Step 3 of the NDS Home Drainage Center wizard.
 * The instructions are server rendered so they stay indexable; this only wires up
 * the show/hide behaviour and deep linking to a step.
 */
function init() {
	const roots = document.querySelectorAll('[data-drainage-instructions]');

	roots.forEach((root) => {
		root.querySelectorAll('[data-drainage-toggle]').forEach((toggle) => {
			toggle.addEventListener('click', () => togglePanel(toggle));
		});

		openFromHash(root);
	});
}

function togglePanel(toggle) {
	const panel = toggle.closest('[data-drainage-panel]');

	if (!panel) return;

	const body = panel.querySelector('[data-drainage-body]');
	const willOpen = !panel.classList.contains('is-open');

	panel.classList.toggle('is-open', willOpen);
	toggle.setAttribute('aria-expanded', String(willOpen));

	if (body) {
		if (willOpen) {
			body.removeAttribute('hidden');
		} else {
			body.setAttribute('hidden', '');
		}
	}
}

/**
 * Supports linking straight to a single step, e.g. /instructions#step-3.
 */
function openFromHash(root) {
	const hash = window.location.hash;

	if (!hash || hash.length < 2) return;

	let target;

	try {
		target = root.querySelector(hash);
	} catch (e) {
		return;
	}

	if (!target || !target.matches('[data-drainage-panel]')) return;

	const toggle = target.querySelector('[data-drainage-toggle]');

	if (toggle && !target.classList.contains('is-open')) {
		toggle.click();
	}

	target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export { init };
